<div class="tos-table-container">
  <!--search and filter-->
  <div class="filter_container" *ngIf="searchBarConfig || filterConfig || viewConfig">

    <div class="view-selection-container" *ngIf="viewConfig">
      <app-multi-select
        #viewselector
        id="view-selector"
        [options]="viewConfig.viewOptions"
        [displayKey]="'name'"
        [valueKey]="'id'"
        [isMultiSelect]="false"
        [placeholder]="'viewConfig?.placeHolder'"
        (selectionChange)="handleViewChange($event)"
      ></app-multi-select>
    </div>

    <div class="search_bar" *ngIf="searchBarConfig">
      <div class="search_container">
        <input
          type="text"
          name="search_table"
          id="search_table"
          [(ngModel)]="searchTerm"
          [placeholder]="searchBarConfig.placeHolder ?? 'Search...'"
          (keyup)="handleTableSearch($event)"
        >
        <img src="assets/icons/search_icon.svg" class="search_icon">
      </div>
    </div>

    <div class="filter_btn" *ngIf="filterConfig">
      <div class="filter_btn" *ngIf="filterConfig">
        <nz-badge [nzCount]="rawFilterData?.filterConditions.length + preSetFilters?.filterConditions.length"
                  [nzOverflowCount]="99">
          <button (click)="filter()">
            <img src="assets/icons/filter.svg">
            Filters
            <!--        <app-svg-icon *ngIf="isFilterApplied" [path]="'assets/icons/circle_icon.svg'"
                                  style="background-color: var(&#45;&#45;error-500);height: 8px;width: 8px"></app-svg-icon>-->
          </button>
        </nz-badge>
      </div>
    </div>
  </div>

  <!--stats-->
  <div class="tos-table-template">
    @if (showTableStats) {
      <div class="table-stats">
        <div class="left">
          <div class="total">Total {{ tableMeta.name }}: {{ stats.total }}</div>
          <div class="active">Active: {{ stats.active }}</div>
          <div class="inactive">Inactive: {{ stats.inactive }}</div>
        </div>
      </div>
    }

    <!--table-->
    <app-ag-grid-wrapper
      style="height: 100%; width: 100%;"
      [tableMeta]="tableMeta"
      [tableRows]="dataListResponse.records"
      [tableMenuOptions]="tableMenuOptions"
      [orderBy]="dataListRequest.orderBy"
      [selectedItems]="selectedItems"
      [allTableRecordsSelected]="allTableRecordsSelected"
      (sortChange)="sortData($event)"
      (selectedItemsChange)="handleSelectedItemsChange($event)"
      (rowActionTriggered)="rowActionTriggered.emit($event)"
      (tableMenuOptionSelected)="tableMenuOptionSelected.emit($event)"
    ></app-ag-grid-wrapper>

    @if (dataListResponse.records?.length > 0) {
      <div class="pagination">
        <div class="button_wrapper_left">
          <button (click)="handlePreviousBtnClick()" [disabled]="!(dataListRequest.page > 0)"><img
            src="assets/icons/left-arrow.svg" /> Previous
          </button>
        </div>
        <ng-container>
          <div class="goto_page_box">
            <input type="number" min="1" [max]="totalPages" [(ngModel)]="customPageInput" [style.width.px]="inputWidth"
                  (ngModelChange)="onDebouncedPageInputChange()" />
            <span class="hidden-span" #widthCalculator>{{ customPageInput }}</span>
            <span class="total_pages_text">of {{ totalPages }}</span>
          </div>
        </ng-container>

        <div class="button_wrapper_right">
          <div class="rows_per_page">
            Rows per page
            <app-multi-select
              style="width: 80px;"
              [isMultiSelect]="false"
              [options]="rowsPerPageOptions"
              [displayKey]="'label'"
              [valueKey]="'value'"
              [returnRawValue]="false"
              [selectedItems]="[{ value: dataListRequest.limit, label: dataListRequest.limit }]"
              (selectionChange)="handleRowsPerPage($event)"
            ></app-multi-select>
          </div>
          <button (click)="handleNextButtonClick()"
                  [disabled]="!(this.dataListRequest.page >= 0 && this.dataListRequest.page < this.totalPages - 1)">Next
            <img src="assets/icons/right-arrow.svg"></button>
        </div>
      </div>
    }


  </div>
</div>
